module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-33c5b2de12da237e223d99c3e8dc5888.png";